var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.$style.container},[_c('h1',{class:_vm.$style.header},[_vm._v(" UUPS! ")]),_c('h2',{class:_vm.$style.text},[_vm._v(" Wir sind am suchen, aber konnten für diese Kategorie nichts finden.. ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }